<template>
  <div class="thecontainer">
    <CofocusLogo style="margin-top: 100px" />
    <div class="linkname toplink">
      50 minute 1-1 coworking sessions over video.
    </div>
    <div class="linkname">
      <span class="rocky">🚀</span><span class="cofocusx">www.cofocus.one</span
      ><span class="rocky2">🚀</span>
    </div>
  </div>
</template>

<script>
import CofocusLogo from "./CofocusLogo";

export default {
  name: "DummyCofocus",
  components: {
    CofocusLogo,
  },
};
</script>

<style scoped>
.thecontainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "F37 Ginger Regular", sans-serif;
}
.linkname {
  font-family: "F37 Ginger Regular", sans-serif;
  margin-top: 20px;
  font-size: 28px;
  color: #111;
}

.cofocusx {
  font-size: 23px;
}

.rocky {
  margin-right: 12px;
  font-size: 22px;
}
.rocky2 {
  margin-left: 12px;
  font-size: 22px;
}
.toplink {
  margin-top: 110px;
}
</style>